/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IObrienSimpleDivViewProps } from './obrien-simple-div';

export default (props: IObrienSimpleDivViewProps) => {
    const { obID, obClassName } = props;
    return (
        <div id={obID} className={obClassName}></div>
    );
};
